import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CompanyInterface } from '../../core/models/company.model';
import { AlertComponent } from '../../shared/components/alert/alert.component';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-company-information',
  templateUrl: './company-information.component.html',
  styleUrls: ['./company-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AlertComponent],
})
export class CompanyInformationComponent {
  @Input() company: CompanyInterface;
}
